import React from "react";
import { AboutHero } from "../components/AboutUs";
import Navbar from "../components/Navbar/Navbar";

const About = () => (
  <main>
    <Navbar />
    <AboutHero />
    {/* <VisionMission />
    <WhyChooseUs /> */}
  </main>
);

export default About;
